<svg
  xmlns="http://www.w3.org/2000/svg"
  width="23"
  height="23"
  viewBox="0 0 23 23"
  fill="none"
  [ngStyle]="overrideStyle"
>
  <path
    d="M19.751 13.2219H13.751V19.2219H11.751V13.2219H5.75098V11.2219H11.751V5.22192H13.751V11.2219H19.751V13.2219Z"
    fill="white"
  />
</svg>
